<script setup lang="ts">
const props = defineProps<{
	competitor: App.Data.Competitor.CompetitorData
}>()

const form = useForm<App.Data.Competitor.UpdateCompetitorData>({
	method: 'PUT',
	url: route('competitors.update', { competitor: props.competitor.uuid }),
	fields: {
		name: props.competitor.name,
		store_url: props.competitor.store_url,
	},
	errorBag: 'updateCompetitor',
	reset: false,
})

const deleteForm = useForm({
	method: 'DELETE',
	url: route('competitors.destroy', { competitor: props.competitor.uuid }),
	fields: {},
	errorBag: 'deleteCompetitor',
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<ui-form variant="settings" @submit.prevent="form.submit">
			<ui-form-settings-item>
				<template #label>
					<ui-label for="name">
						{{ t('validation.attributes.name') }}
					</ui-label>
				</template>

				<ui-input
					id="name"
					v-model="form.fields.name"
					required
					autofocus
				/>
				<ui-form-error :message="form.errors.name" />
			</ui-form-settings-item>

			<ui-form-settings-item>
				<template #label>
					<ui-label for="store_url">
						{{ t('validation.attributes.store_url') }}
					</ui-label>
				</template>

				<template #description>
					{{ t('app.changing_store_url_notice') }}
				</template>

				<ui-input
					id="store_url"
					v-model="form.fields.store_url"
					required
					type="url"
				/>
				<ui-form-error :message="form.errors.store_url" />
			</ui-form-settings-item>

			<ui-separator />

			<div class="flex items-center gap-8">
				<ui-button :loading="form.processing" class="w-fit" @click="form.submit">
					{{ t('app.buttons.save') }}
					<template #icon>
						<i-ph-arrow-right />
					</template>
				</ui-button>

				<ui-dialog>
					<ui-dialog-trigger class="text-destructive text-sm">
						{{ t('app.buttons.delete') }}
					</ui-dialog-trigger>

					<ui-dialog-content>
						<ui-dialog-header>
							<ui-dialog-title>
								{{ t('app.delete_competitor_dialog_title') }}
							</ui-dialog-title>
						</ui-dialog-header>

						<ui-dialog-description>
							<div>{{ t('app.delete_competitor_dialog_text') }}</div>

							<ui-button
								variant="destructive"
								:loading="deleteForm.processing"
								class="mt-4"
								@click="deleteForm.submit"
							>
								{{ t('app.buttons.delete') }}
							</ui-button>
						</ui-dialog-description>

						<ui-dialog-close
							class="ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none"
						>
							<i-ph-x-bold class="size-4" />
						</ui-dialog-close>
					</ui-dialog-content>
				</ui-dialog>
			</div>
		</ui-form>
	</content-wrapper>
</template>
